import axios from "axios";
import apiInstance from '../../api/api';
//import authHeader from "../../helpers/header";
//import AWS from 'aws-sdk';
import fileSaver from 'file-saver';

import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import AuthLayout from "../../components/AuthLayout/AuthLayout";
import format from "../../helpers/format";


import { API_URL, MEDIA_URL, S3_KEY, S3_SECRET, S3_REGION, S3_BUCKET } from "../../configs";

  
function ResourcesProcess(props) {
    const search = useLocation().search
    const searchParams = new URLSearchParams(search)
    const [downloadCount, setDownloadCount] = useState(0);
    const [data, setData] = useState([]);
    const [downloadProgress, setDownloadProgress] = useState({}); // { fileId: percent }
    const [downloadStatus, setDownloadStatus] = useState({}); // { fileId: 'pending'|'downloading'|'done'|'error' }


    // Download a single file from B2
    const downloadFileFromB2 = async (file, resourceId) => {
        try {
            setDownloadStatus(prev => ({ ...prev, [file._id]: 'downloading' }));
            // Get signed B2 URL from backend
            const signedUrlRes = await apiInstance.get(`${API_URL}files/b2_signed_url/${file._id}`);
            const signedUrl = signedUrlRes.data?.url || signedUrlRes.data?.signed_url;
            if (!signedUrl) throw new Error('No signed URL');

            // Download file with progress
            const response = await axios.get(signedUrl, {
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / (progressEvent.total || file.file_size || 1));
                    setDownloadProgress(prev => ({ ...prev, [file._id]: percent }));
                }
            });
            const blob = new File([response.data], file.filename);
            fileSaver.saveAs(blob);
            setDownloadStatus(prev => ({ ...prev, [file._id]: 'done' }));
            setDownloadCount(count => count + 1);
        } catch (err) {
            setDownloadStatus(prev => ({ ...prev, [file._id]: 'error' }));
        }
    };

    // Bulk download all files
    const fileDownloadHandler = async (data) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].files && data[i].files.length) {
                for (const file of data[i].files) {
                    await downloadFileFromB2(file, data[i].resourceId);
                }
            }
        }
    };


    const handleDownload = (item) => {
        fileDownloadHandler(item);
    };


    useEffect(() => {
        let ids = searchParams.get('resources_id');
        let format = searchParams.get('format');

        async function getResourcesFileData(ids) {
            let requestUrl = API_URL + `files/getbulk/?ids=${ids}`;
            if (format) {
                requestUrl += `&format=${format}`;
            }
            const res = await apiInstance.get(requestUrl);
            if (res.status === 200) {
                setData(res.data);
            }
        }
        if (ids) getResourcesFileData(ids);
    }, []);

    // Auto-download when data is loaded
    useEffect(() => {
        if (data && data.length > 0) {
            fileDownloadHandler(data);
        }
    }, [data]);
    


    return (
        <AuthLayout>
            <header className={"d-flex justify-content-between align-items-center mb-4"}>
                <h2 className="fs-5">Download resource files</h2>
                <button
                    type="button"
                    className="btn btn-primary"
                    disabled
                >
                    Downloading {data.length} files...
                </button>
            </header>
            <div>
                {data && (
                    <div className="row">
                        {data.map((resource, index) => (
                            <div key={index} className="col-md-3">
                                <p className="text-muted text-center mt-2 mb-1 py-0">
                                    <Link to={`/resources/view/${resource.resourceId}`} target="_blank" rel="noreferrer">
                                        <span className="me-2 mt-1 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">{resource.resourceId}</span>
                                    </Link>
                                </p>
                                {resource.files && resource.files.map((file, i) => (
                                    <div key={i} className="mb-2">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <span className="fw-bold">{file.filename}</span>
                                            <span className="badge bg-secondary ms-2">{file.format}</span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <span className="me-2">{file.file_size ? format.formatBytes(file.file_size) : 'Unknown size'}</span>
                                            <span className="me-2">
                                                {downloadStatus[file._id] === 'downloading' && (
                                                    <span className="text-info">Downloading...</span>
                                                )}
                                                {downloadStatus[file._id] === 'done' && (
                                                    <span className="text-success">Done</span>
                                                )}
                                                {downloadStatus[file._id] === 'error' && (
                                                    <span className="text-danger">Error</span>
                                                )}
                                            </span>
                                            <span style={{ minWidth: 60 }}>
                                                {downloadProgress[file._id] ? (
                                                    <progress value={downloadProgress[file._id]} max="100" style={{ width: '60px' }} />
                                                ) : null}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                )}
                {downloadCount > 0 && (
                    <div className={`alert alert-success py-2 my-4`} role="alert">
                        {`${downloadCount} file${downloadCount > 1 ? 's' : ''} downloaded`}
                    </div>
                )}
            </div>
        </AuthLayout>
    );
}
function mapStateToProps(state) {
    const { token } = state.auth;
    
    const { message, messageType } = state.message;
    return {
        token,
        message,
        messageType,
    };
}

export default connect(mapStateToProps)(ResourcesProcess);
      